export const splitName = (fullName = "") => {
  const parts = String(fullName).trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return { firstName: "", middleName: "", lastName: "" };
  }

  if (parts.length === 1) {
    return { firstName: parts[0], middleName: "", lastName: "" };
  }

  if (parts.length === 2) {
    return { firstName: parts[0], middleName: "", lastName: parts[1] };
  }

  if (parts.length === 3) {
    return {
      firstName: parts[0],
      middleName: parts[1],
      lastName: parts[2],
    };
  }

  // ✅ For 4 or more parts:
  // first 2 words = first name
  // last word = last name
  // remaining middle words = middle name
  return {
    firstName: parts.slice(0, 2).join(" "),
    middleName: parts.slice(2, -1).join(" "),
    lastName: parts[parts.length - 1],
  };
};

export const joinName = ({ firstName = "", middleName = "", lastName = "" }) =>
  [firstName, middleName, lastName].filter(Boolean).join(" ").replace(/\s+/g, " ").trim();